<template>
  <div class="about clearfix">
    <ui-navigation></ui-navigation>
    <br>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/layout/Navigation.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
  name: 'About',
  components:{
    'ui-footer': Footer,
    'ui-navigation': Navigation
  }
}
</script>

<style scoped lang='less'>
.about{
}
@media (max-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue